// extracted by mini-css-extract-plugin
export default {"mainWrapper":"TasksRouter_mainWrapper__tlrEn","header":"TasksRouter_header__a2Kh8","body":"TasksRouter_body__GXdUw","eachSection":"TasksRouter_eachSection__81oYs"};